import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { environment } from '@environments/environment';
import { ErrorComponent } from '@errors/error.component';
import { AuthService } from '@providers/auth/auth.service';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { ModelsToolsService } from '@providers/models-tools/models-tools.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(router, authService, globalDataService, requestService, requestV2Service, modelsToolsService) {
        var _this = this;
        this.router = router;
        this.authService = authService;
        this.globalDataService = globalDataService;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.modelsToolsService = modelsToolsService;
        this.title = 'customer-area';
        this.state = 'idle';
        this.isFirstConnection = false;
        this.isMenuOpen = false;
        this.closePopups = false;
        if (localStorage.hasOwnProperty('access_token')) {
            localStorage.removeItem('access_token');
        }
        this.disableErrorProd();
        this.authService.retrieveTokenFromUrl();
        this.isStandAlone = false;
        this.isInit = false;
        this.isLoadingProject = false;
        this.currentProject = null;
        router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                if (event.url.startsWith('/quotations/')) {
                    _this.isStandAlone = true;
                }
                _this.updateBodyPageClass(event.url);
                _this.closeMenu();
                var projectId = _this.retrieveProjectId(event.url);
                var isNewProject = !_this.currentProject || _this.currentProject.id !== projectId;
                if (_this.isInit && projectId && isNewProject) {
                    _this.requestAndNavigateToProject(projectId);
                }
            }
        });
    }
    AppComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var projectStepCategoryResult, stepResult, units;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.authService.isAuthenticated()) {
                            this.retrieveUserInformationsData();
                        }
                        else {
                            this.authService.redirectOAuth();
                        }
                        return [4 /*yield*/, this.requestV2Service.getStepCategories()];
                    case 1:
                        projectStepCategoryResult = _a.sent();
                        this.globalDataService.stepsCategory = projectStepCategoryResult.items;
                        return [4 /*yield*/, this.requestV2Service.getProjectSteps()];
                    case 2:
                        stepResult = _a.sent();
                        this.globalDataService.steps = stepResult.items;
                        this.globalDataService.steps = this.globalDataService.steps
                            .sort(function (a, b) { return a.order - b.order; });
                        return [4 /*yield*/, this.requestV2Service.getUnitTypes()];
                    case 3:
                        units = _a.sent();
                        this.globalDataService.units = units.items;
                        return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.componentAdded = function (event) {
        var _this = this;
        if (event instanceof ErrorComponent) {
            return;
        }
        if (event.openMenu) {
            event.openMenu.subscribe(function () {
                _this.openMenu();
            });
        }
    };
    AppComponent.prototype.updateBodyPageClass = function (url) {
        var _this = this;
        var currentPage = url.substring(url.lastIndexOf('/') + 1);
        var queryStringIndex = currentPage.indexOf('?');
        if (queryStringIndex !== -1) {
            currentPage = currentPage.substring(0, queryStringIndex);
        }
        // Remove previous page-* classes
        var currentClasses = this.mainContainer.nativeElement.classList;
        currentClasses.forEach(function (className) {
            if (className.indexOf('page-') === 0) {
                _this.removeClass(_this.mainContainer, className);
            }
        });
        this.addClass(this.mainContainer, "page-" + currentPage);
    };
    AppComponent.prototype.addClass = function (element, className) {
        if (!element) {
            return;
        }
        if (!element.nativeElement.classList.contains(className)) {
            element.nativeElement.classList.add(className);
        }
    };
    AppComponent.prototype.removeClass = function (element, className) {
        if (!element) {
            return;
        }
        element.nativeElement.classList.remove(className);
    };
    AppComponent.prototype.openMenu = function () {
        this.addClass(this.mainContent, 'menu-opened');
    };
    AppComponent.prototype.closeMenu = function () {
        this.removeClass(this.mainContent, 'menu-opened');
    };
    AppComponent.prototype.initProjectsList = function (data) {
        var projects = [];
        data.forEach(function (project) {
            var lightProject = tslib_1.__assign({}, project);
            projects.push(lightProject);
        });
        return projects;
    };
    AppComponent.prototype.retrieveUserInformationsData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accountInformation, projectsResult, projects, projectId, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.state = 'loading';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.requestV2Service.getAccount()];
                    case 2:
                        accountInformation = _a.sent();
                        this.user = accountInformation;
                        this.globalDataService.user = accountInformation;
                        if (this.isStandAlone) {
                            this.state = 'ready';
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.requestV2Service.getProjects(this.user.id, true, true)];
                    case 3:
                        projectsResult = _a.sent();
                        projects = this.initProjectsList(projectsResult.items);
                        if (projects.length <= 0) {
                            this.onError(new Error('Aucun projet disponible.'));
                            return [2 /*return*/];
                        }
                        this.globalDataService.setProjects(projects);
                        this.isInit = true;
                        projectId = this.retrieveProjectId(this.router.url);
                        if (!projectId) {
                            projectId = this.retrieveDefaultProjectId(projects);
                            this.router.navigate(["/projects/" + projectId + "/dashboard"]);
                            return [2 /*return*/];
                        }
                        this.requestAndNavigateToProject(projectId);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.onError(new Error('Impossible de récupérer la liste des projets.'));
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.requestAndNavigateToProject = function (projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var projectsResult, _a, err_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isLoadingProject) {
                            return [2 /*return*/];
                        }
                        projectsResult = this.globalDataService.getProjects();
                        if (projectsResult && projectsResult.items && !this.isProjectExisting(projectsResult.items, projectId)) {
                            this.onError(new Error("Vous n'avez pas accès à ce projet."));
                            return [2 /*return*/];
                        }
                        this.isLoadingProject = true;
                        this.state = this.router.url.includes('materials') ? this.state : 'loading';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.requestV2Service.getProject(projectId, true)];
                    case 2:
                        _a.currentProject = _b.sent();
                        this.checkWrongRoutes();
                        this.globalDataService.setCurrentProjectId(this.currentProject.id);
                        this.globalDataService.setCurrentProject(this.currentProject);
                        if (!this.modelsToolsService.isStepValid(this.currentProject._related.steps[0].id)) {
                            this.onError(new Error('Ce projet est encore en cours de finalisation.'));
                            this.errorLink = "https://monprojet.littleworker.fr/projects/" + this.currentProject.id + "/";
                            return [2 /*return*/];
                        }
                        if (localStorage.getItem('isFirstConnection') !== 'false') {
                            this.isFirstConnection = true;
                            localStorage.setItem('isFirstConnection', 'false');
                        }
                        this.isLoadingProject = false;
                        this.state = 'ready';
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.currentProject = null;
                        this.globalDataService.setCurrentProject(null);
                        this.isLoadingProject = false;
                        switch (err_1.message) {
                            // TODO: Handle other case
                            default:
                                this.onError(new Error("Le projet que vous recherchez n'est pas ou plus disponible."));
                                break;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AppComponent.prototype.onError = function (error) {
        this.errorMessage = error.message;
        this.state = 'error';
    };
    AppComponent.prototype.retrieveProjectId = function (url) {
        var args = url.split('/');
        var projectId = null;
        if (args.length >= 3) {
            projectId = args[2];
        }
        return projectId;
    };
    AppComponent.prototype.retrieveDefaultProjectId = function (projects) {
        if (projects === null || projects.length <= 0) {
            return null;
        }
        return projects[0].id;
    };
    AppComponent.prototype.isProjectExisting = function (projects, projectId) {
        if (!projects || projects.length <= 0) {
            return false;
        }
        var found = projects.find(function (i) { return i.id === projectId; });
        return !!found;
    };
    AppComponent.prototype.disableErrorProd = function () {
        if (environment.production) {
            window.console.log = function () { };
        }
    };
    AppComponent.prototype.checkWrongRoutes = function () {
        var categoryRange = this.globalDataService.stepsCategory
            .filter(function (i) { return i.name !== 'Études' || i.name !== 'S.A.V' || i.name !== 'Travaux'; })
            .map(function (i) { return i.id; });
        var stepsRange = this.globalDataService.steps
            .filter(function (i) { return categoryRange.includes(i.id_project_step_category); });
        var currentRoute = window.location.pathname.split('/');
        if (typeof stepsRange.find(function (i) { return currentRoute.includes(i.id); }) !== 'undefined') {
            this.router.navigate(['projects', this.currentProject.id, 'dashboard']);
        }
    };
    AppComponent.prototype.displayMask = function (event) {
        this.isMenuOpen = event;
        this.closePopups = false;
    };
    AppComponent.prototype.inClosePopups = function () {
        this.closePopups = true;
        this.isMenuOpen = false;
    };
    return AppComponent;
}());
export { AppComponent };
